import { Box, FormControlLabel, styled } from '@mui/material';
import { Typography, colors, Checkbox } from '@sweep-io/sweep-design';

interface ToggleFilterProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const StyledFieldLabel = styled('label')({});

export function ToggleFilter({ checked, label, onChange }: ToggleFilterProps) {
  return (
    <Box
      className="toggle-filter"
      display="flex"
      gap={1}
      alignItems="center"
      sx={{
        background: colors.white,
        pl: 1,
        pr: 1,
        border: `1px solid ${colors.grey[120]}`,
        borderRadius: '4px',
      }}
    >
      <FormControlLabel
        label={
          <StyledFieldLabel sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography wordBreak="keep-all" whiteSpace="nowrap" variant="caption">
              {label}
            </Typography>
          </StyledFieldLabel>
        }
        control={
          <Checkbox checked={checked} onChange={(event) => onChange(event.target.checked)} />
        }
      />
    </Box>
  );
}
